import React from 'react'
import { useLocation } from 'react-router-dom'
import { parse } from 'query-string'

export function FullscreenImage() {
  const location = useLocation()
  const parsed = parse(location.search)

  // Handle array case - take first value if array, otherwise use as is
  let uri = parsed.uri
  if (Array.isArray(uri)) {
    uri = uri[0]
  }

  // Validate URI to prevent XSS attacks
  const isValidUri = url => {
    if (!url || typeof url !== 'string') return false

    // Reject javascript:, data:, and vbscript: protocols to prevent XSS
    const lowerUrl = url.toLowerCase().trim()

    if (
      // eslint-disable-next-line no-script-url
      lowerUrl.startsWith('javascript:') ||
      lowerUrl.startsWith('data:') ||
      lowerUrl.startsWith('vbscript:')
    ) {
      return false
    }

    try {
      const parsed = new URL(url, window.location.origin)
      // Only allow http and https protocols
      return parsed.protocol === 'http:' || parsed.protocol === 'https:'
    } catch {
      return false
    }
  }

  const safeUri = isValidUri(uri) ? uri : ''

  if (!safeUri) {
    return <div>Invalid image URL</div>
  }

  return (
    <img style={{ maxWidth: '100%', maxHeight: '100%' }} src={safeUri} alt="" />
  )
}
